/* ----------------------------------
Import modules
---------------------------------- */

import FilterController from '@meteora-digital/filters';

/* ----------------------------------
PageFiltersController
---------------------------------- */

export default class PageFiltersController extends Classy {
  constructor(form) {
    let options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    super();
    // The form element
    this.form = form;
    // A timeout object
    this.timeouts = {};
    // The value of the filters
    this.value = {};
    // The query string
    this.queryString = '';

    // Merge the defaults with the options
    this.settings = Object.assign({
      hardFilters: [],
      softFilters: ['start'],
      blacklist: ['stage', 'simpleselector']
    }, options);

    // Create a new FilterController
    this.FilterController = new FilterController(this.getFormAction());

    // Success and Error events for the FilterController
    this.FilterController.on('success', response => this.success(response));
    this.FilterController.on('error', response => this.error(response));

    // Convert all items in the blacklist to lowercase
    this.settings.blacklist = this.settings.blacklist.map(item => item.toLowerCase());

    // Prevent the form from submitting
    this.form.addEventListener('submit', e => {
      e.preventDefault();
      // Submit the filters
      this.submit();
    });

    // When the form is changed
    this.form.addEventListener('change', () => this.change());
    // When the form is reset
    this.form.addEventListener('reset', () => {
      // Clear the form change timeout
      clearTimeout(this.timeouts['form']);

      // Reset the filters
      this.reset();

      // Loop the form elements and, and remove them from the filter by name
      for (let index = 0; index < this.form.elements.length; index++) {
        const input = this.form.elements[index];

        // If there is no key, continue
        if (!input.name || input.name === "") continue;

        // Remove the filter
        this.remove(input.name);
      }

      // Submit the filters
      this.submit();
    });

    // Get the URL filters
    // setTimeout(() => {
    this.getURLFilters();
    // }, 500);
  }
  getFormAction() {
    // If the form action has ?stage=Stage, remove it
    return this.form.action.replace('?stage=Stage', '');
  }
  submit() {
    // Clear the update timeout
    clearTimeout(this.timeouts['update']);

    // The submit callback
    this.callback('submit');

    // Apply the filters with the FilterController
    this.timeouts['update'] = setTimeout(() => {
      this.apply();
    }, 1000);
  }
  removeSoftFilters() {
    // Loop through the soft filters and remove them
    this.settings.softFilters.forEach(key => this.remove(key));
  }
  reset() {
    // Loop through the soft filters and remove them
    this.removeSoftFilters();

    // Loop through the Filter value object and remove all the filters that are not hard filters
    Object.keys(this.value).forEach(key => {
      // If the key is a hard filter, continue
      if (this.settings.hardFilters.includes(key)) return;

      // Remove the filter
      this.remove(key);
    });

    // The reset callback
    this.callback('reset');
  }
  change() {
    // Clear the form change timeout
    clearTimeout(this.timeouts['form']);
    if (this.FilterController.worker) {
      // Abort the worker request
      this.FilterController.worker.terminate();
    }

    // Set the form timeout
    this.timeouts['form'] = setTimeout(() => {
      // Get the form data
      const data = new FormData(this.form);
      // Set the keys array
      let keys = [];

      // Reset the filters
      this.reset();

      // Loop through the soft filters and remove them
      this.removeSoftFilters();

      // Loop the form data and set the filter
      for (const [key, value] of data.entries()) {
        // If the value is empty, remove the filter, otherwise set it
        if (value === "") {
          this.remove(key);
        } else {
          if (keys.includes(key)) {
            this.add(key, value);
          } else {
            this.set(key, value);
          }
          keys.push(key);
        }
      }

      // Submit the filters
      this.submit();

      // Update the value
      this.value = this.FilterController.value;

      // Update the query string
      this.getQueryString();

      // The change callback
      this.callback('change');
    }, 100);
  }
  isInvalid(key) {
    // If there is no key, invalid
    if (!key || key === "") return true;

    // If the key is in the blacklist, invalid
    // if (this.settings.blacklist.includes(key.toLowerCase())) return true;

    // We will check for partial matches in the blacklist to remove keys that arent wanted
    if (this.settings.blacklist.some(blacklistItem => key.toLowerCase().includes(blacklistItem))) return true;
    return;
  }
  getURLFilters() {
    // Get all the URL search params
    const params = new URLSearchParams(window.location.search);

    // If there are no params, return
    if (!params || params.size === 0) return;

    // Loop through the URL search params and set the filter
    for (const [key, value] of params.entries()) {
      // If the key is invalid, continue
      if (this.isInvalid(key)) continue;

      // Create a new change event for the input
      const e = new Event('change');

      // If the value is empty, remove the filter
      if (value === "") this.remove(key);

      // Otherwise set it
      else {
        // Find the form elements that matches the key
        const inputs = [...this.form.querySelectorAll(`[name="${key}"]`)];

        // Split the value by comma
        value.split(',').forEach(val => {
          this.add(key, val);

          // If the input doesnt exist, return
          if (inputs.length === 0) return;

          // Get the input for this val
          const input = inputs.filter(i => i.value == val)[0] || inputs[0];

          // If the input is a checkbox or radio, check it
          if (input.type === 'checkbox' || input.type === 'radio') {
            if (input.value === val) {
              input.checked = true;
              // Dispatch a change event
              input.dispatchEvent(e);
            }
            ;
          }

          // Else if the input is a select with multiple attribute, select the options
          else if (input.multiple) {
            // Loop through the options
            [...input.options].forEach(option => {
              // If the option value is not the same as the val, return
              if (option.value !== val) return;

              // Select the option
              option.selected = true;
            });

            // Dispatch a change event
            input.dispatchEvent(e);
          }

          // Set the value of the input
          else {
            input.value = val;
            // Dispatch a change event
            input.dispatchEvent(e);
          }
          ;
        });
      }
    }

    // Update the value to match the FilterController value
    this.value = this.FilterController.value;

    // Update the query string
    this.getQueryString();

    // The getURLFilters callback
    this.callback('getURLFilters');
  }
  getQueryString() {
    // Convert the value object to a query string
    this.queryString = new URLSearchParams(this.value).toString();
    // The getQueryString callback
    this.callback('getQueryString');
    // Return the query string
    return this.queryString;
  }
  paginate() {
    let pagination = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    // If the pagination is not an array or the array is empty, return
    if (!Array.isArray(pagination) || pagination.length === 0) return;

    // Loop through the pagination links
    pagination.forEach(link => {
      // Convert the link's href to a URL
      const url = new URL(link.href);
      // Get the page number from the URL
      const pageNum = url.searchParams.get('start');

      // If there is no page number, return
      if (!pageNum) return;

      // When the link is clicked, go to the page
      link.addEventListener('click', e => {
        e.preventDefault();
        // Set the 'start' filter
        this.set('start', pageNum);
        // Submit the filters
        this.submit();
        // The pageChanged callback
        this.pageChanged();
      });
    });

    // The paginate callback
    this.callback('paginate');
  }
  add(key, value) {
    if (this.isInvalid(key)) return;

    // Add the filter
    this.FilterController.add(key, value);
  }
  set(key, value) {
    if (this.isInvalid(key)) return;

    // Set the filter
    this.FilterController.set(key, value);
  }
  remove(key) {
    // If there is no key, return
    if (!key || key === "") return;
    // Remove the filter
    this.FilterController.remove(key);
  }
  success(response) {
    // Call the complete event
    this.complete(response);
    // The success callback
    this.callback('success', response);
  }
  error(response) {
    // Call the complete event
    this.complete(response);
    // The error callback
    this.callback('error', response);
  }
  complete(response) {
    setTimeout(() => {
      // Update the URL
      this.FilterController.updateURL();

      // Get the URL filters
      this.getURLFilters();

      // Remove soft filters
      this.removeSoftFilters();

      // The complete callback
      this.callback('complete', response);
    }, 100);
  }
  pageChanged() {
    // The paginated callback
    this.callback('pageChanged');
  }
  apply() {
    // Apply the filters with the FilterController
    this.FilterController.apply();
  }
}